/* eslint-disable */
if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      this.errorHtml = document.getElementById('pickup-error').content.firstElementChild.cloneNode(true);
      this.noResultsHtml = document.getElementById('pickup-no-results').content.firstElementChild.cloneNode(true);
      this.stockistNoResultsHtml = document.getElementById('stockist-no-results').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.pickupAvailability = [];

      window.stockistResultSelected = (result) => {
        if (!result) return;
        const availabilityLocation = this.pickupAvailability.find((item) => result.name === item.name);
        const $locationName = this.querySelector('.caption-large');
        const $subText = this.querySelector('.pickup--sub');
        const $topText = this.querySelector('.find-store-modal-wrap .pickup--location');
        if (availabilityLocation) {
          const locationHtml = `In stock at <span class="pickup--location">${result.name}</span>.`;
          if ($locationName) {
            $locationName.innerHTML = locationHtml;
          }
          if ($topText && window.availableText) {
            $topText.innerHTML = window.availableText;
          }
          if ($subText && window.availableTextSub) {
            $subText.innerHTML = window.availableTextSub;
          }
        } else {
          const locationHtml = `Not in stock at <span class="pickup--location">${locationData.name}</span>.`;
          if ($locationName) {
            $locationName.innerHTML = locationHtml;
          }
          if ($topText && window.unavailableText) {
            $topText.innerHTML = window.unavailableText;
          }
          if ($subText) {
            $subText.innerHTML = '';
          }
        }
      };

      this.checkSessionStorageLocation();

      const productFormInput = document.querySelector('.product-form__var-input');
      if (productFormInput) {
        // use mutation observer to detect when the variant changes
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'value') {
              // delay to wait for the variant to be updated
              setTimeout(() => {
                this.fetchAvailability(mutation.target.value);
              }, 1);
            }
          });
        });
        observer.observe(productFormInput, {
          attributes: true,
          attributeFilter: ['value'],
        });
      }
      if (this.dataset.hasOnlyDefaultVariant === 'true') {
        this.fetchAvailability(this.dataset.variantId);
      }
    }

    checkSessionStorageLocation() {
      // check and get selected location from sessionStorage
      if (typeof(Storage) !== 'undefined') {
        const selectedLocation = sessionStorage.getItem('selectedLocation');
        if (selectedLocation) {
          const locationData = JSON.parse(selectedLocation);
          if (this.classList.contains('pickup__in-store--not-selected')) {
            const $pickupSub = this.querySelector('.pickup--sub');
            if ($pickupSub) {
              const locationHtml = `Select a size to find out if it's available at <span class="pickup--location">${locationData.name}</span>.`;
              $pickupSub.innerHTML = locationHtml;
            }
          } else {
            const $locationName = this.querySelector('.caption-large');
            if ($locationName) {
              if (!window.Stockist?.__widget?._client?._store?.getCurrentResults) return;
              const availabilityLocation = this.pickupAvailability.find((item) => locationData.name === item.name);
              if (availabilityLocation) {
                if (!window.Stockist?.__widget?._client?._store?.getCurrentResults) return;
                const currentResults = window.Stockist.__widget._client._store.getCurrentResults();
                // check if cached result is in the current results
                if (!currentResults.results.find(result => result.name === locationData.name)) {
                  currentResults.results.unshift(availabilityLocation);
                  const selectedResultsQuery = sessionStorage.getItem('selectedResultsQuery');
                  if (selectedResultsQuery) {
                    const selectedResultsQueryParsed = JSON.parse(selectedResultsQuery);
                    const $searchForm = document.querySelector('.stockist-search-form');
                    if (!$searchForm) return;
                    const $searchInput = $searchForm.querySelector('.stockist-search-field');
                    if (!$searchInput) return;
                    $searchInput.value = selectedResultsQueryParsed.address;
                    const $searchSubmit = $searchForm.querySelector('button');
                    if (!$searchInput) return;
                    $searchSubmit.click();
                    window.stockistResultSelected(locationData);
                  }
                } else {
                  if (!window.Stockist?.__widget?._client?._store?.setSelectedLocation) return;
                  window.Stockist.__widget._client._store.setSelectedLocation({
                    location: locationData,
                    source: 'map',
                  });
                  const locationHtml = `In stock at <span class="pickup--location">${locationData.name}</span>.`;
                  $locationName.innerHTML = locationHtml;
                  this.addDrawerButtonClickEvent();
                }
              } else {
                const locationHtml = `Not in stock at <span class="pickup--location">${locationData.name}</span>.`;
                $locationName.innerHTML = locationHtml;
              }
            }
          }
        }
      }
    }

    fetchAvailability(variantId, onlyPreview = false) {
      this.renderLoading();
      const stockistResults = window.Stockist?.__widget?._client?._store?.getCurrentResults();
      if (!stockistResults) {
        // Called once stockist search is complete
        window.stockistSearchCompleted = () => {
          const $widget = document.getElementById('stockist-widget');
          if (!$widget) return;

          // Initialize drawer
          const drawer = new window.theme.Drawers('BopisDrawer', 'bopis');
          this.fetchAvailability(this.dataset.variantId);
        };
        return;
      } else {
        // Called once stockist search is complete
        window.stockistSearchCompleted = () => {
          this.filterStockistResults();
        };
      }

      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      // check if size is selected or a new product was selected
      let sectionId = 'pickup-availability';
      const sizeOptions = !!document.querySelector('.product-form__input--size.product-form__input input[type=radio]:checked');
      if (sizeOptions) {
        this.classList.remove('pickup__in-store--not-selected');
      } else {
        this.classList.add('pickup__in-store--not-selected');
        sectionId = 'pickup-availability-default';
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=${sectionId}`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML, onlyPreview);
          this.checkSessionStorageLocation();
        })
        .catch(e => {
          console.log('error', e);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderLoading() {
      const loadingOverlay = this.querySelector('.loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.classList.remove('hide');
      }
    }

    renderError() {
      this.innerHTML = this.errorHtml.innerHTML;
      const $refreshButton = this.querySelector('#RefreshPickup')
      if ($refreshButton) {
        $refreshButton.addEventListener('click', this.onClickRefreshList);
      }
    }

    renderNoResults() {
      this.innerHTML = this.noResultsHtml.innerHTML;
      const resultList = document.querySelector('.stockist-result-list');
      if (resultList && !resultList.querySelector('.stockist-result-message')) {
        resultList.append(this.stockistNoResultsHtml);
      }
    }

    filterStockistResults() {
      const self = this;
      // reset all results
      [...document.querySelectorAll('.stockist-result')].forEach((result) => {
        result.classList.remove('available');
        function handleResultClick(e) {
          // close drawer
          const $pickupAvailabilityDrawerClose = document.getElementById('PickupAvailabilityClose');
          if ($pickupAvailabilityDrawerClose) {
            $pickupAvailabilityDrawerClose.click();
          }
          // set selected location to sessionStorage so it can be used across PDP and checkout
          if (typeof(Storage) !== 'undefined' && window.Stockist?.__widget?._client?._store?.getCurrentResults) {
            let clickedResult = e.target;
            // check if target has class stockist-result
            if (!e.target.classList.contains('stockist-result')) {
              clickedResult = clickedResult.closest('.stockist-result');
            }
            const clickedResultName = clickedResult.querySelector('.stockist-result-name').textContent;
            const currentResults = window.Stockist.__widget._client._store.getCurrentResults();
            const selectedLocation = currentResults.results.find((result) => result.name === clickedResultName);
            if (selectedLocation) {
              sessionStorage.setItem('selectedLocation', JSON.stringify(selectedLocation));
            }
            if (currentResults) {
              sessionStorage.setItem('selectedResultsQuery', JSON.stringify(currentResults.query));
            }
            self.checkSessionStorageLocation();
          }
        }
        if (!result.getAttribute('data-click-added')) {
          result.addEventListener('click', handleResultClick);
          result.setAttribute('data-click-added', true);
        }
      });
      const resultListMessage = document.querySelector('.stockist-result-list .stockist-result-message');
      if (resultListMessage) {
        resultListMessage.remove();
      }
      if (!window.Stockist?.__widget?._client?._store?.getCurrentResults) return;
      const stockistResults = window.Stockist.__widget._client._store.getCurrentResults();
      const filteredResults = [];
      stockistResults.results.forEach((result) => {
        const stockistResult = [...document.querySelectorAll('.stockist-result-name')]
          .find(stockistResultName => stockistResultName.textContent === result.name)
          ?.parentElement;
        const availabilityLocation = this.pickupAvailability.find((item) => result.name === item.name);
        if (availabilityLocation) {
          filteredResults.push(result);
          if (stockistResult) {
            stockistResult.classList.add('available');
          }
        }
      });
      if (filteredResults.length > 0) {
        const pickupTop = this.querySelector('.pickup-top');
        if (pickupTop && pickupTop.classList.contains('is-available')) {
          const closestLocation = filteredResults[0];
          if (typeof(Storage) !== 'undefined') {
            const selectedLocation = sessionStorage.getItem('selectedLocation');
            if (selectedLocation) {
              // if there is a selected location in sessionStorage, don't set the first location as selected
              this.addDrawerButtonClickEvent();
              return false;
            }
          }
          if (!window.Stockist?.__widget?._client?._store?.setSelectedLocation) return;
          window.Stockist.__widget._client._store.setSelectedLocation({
            location: closestLocation,
            source: 'map',
          });
        } else {
          this.fetchAvailability(this.dataset.variantId, true);
        }
      } else {
        this.renderNoResults();
      }

      this.addDrawerButtonClickEvent();
    }

    addDrawerButtonClickEvent() {
      const $showDrawerButton = this.querySelector('#ShowPickupAvailabilityDrawer');
      if ($showDrawerButton) {
        if (!$showDrawerButton.getAttribute('data-click-added')) {
          $showDrawerButton.setAttribute('data-click-added', true);
          $showDrawerButton.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
        }
      }
    }
    renderPreview(sectionInnerHTML, onlyPreview = false) {
      // set pickup availability data
      this.pickupAvailability = [];
      const pickupAvailabilityJsonHtml = sectionInnerHTML.querySelector('#pickup-availability-json');
      if (pickupAvailabilityJsonHtml) {
        this.pickupAvailability = JSON.parse(pickupAvailabilityJsonHtml.innerHTML);
      }
      const stockistWidget = document.getElementById('stockist-widget');
      const stockistWrapper = document.getElementById('stockist-wrapper');
      let stockistWrapperDrawer = document.getElementById('stockist-wrapper-drawer');
      if (stockistWidget && stockistWrapperDrawer && stockistWrapper && !onlyPreview) {
        // move the stockist widget out of the pickup availability drawer so it can be reused
        stockistWrapper.innerHTML = '';
        stockistWrapper.append(stockistWidget);
      }

      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer && !onlyPreview) {
        drawer.remove();
      }
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        return;
      }
      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').innerHTML;
      const updatedDrawer = sectionInnerHTML.querySelector('pickup-availability-drawer');
      if (!onlyPreview && updatedDrawer) {
        document.body.appendChild(updatedDrawer);
      }
  
      stockistWrapperDrawer = document.getElementById('stockist-wrapper-drawer');
      if (stockistWidget && stockistWrapperDrawer) {
        if(!onlyPreview) {
          // move the stockist widget to the pickup availability drawer so it can be reused
          stockistWrapperDrawer.innerHTML = '';
          stockistWrapperDrawer.append(stockistWidget);
        }
        this.filterStockistResults();
      }
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);

      if (this.querySelector('#PickupAvailabilityClose')) {
        this.querySelector('#PickupAvailabilityClose').addEventListener('click', () => {
          this.hide();
        });
      }

      this.addEventListener('keyup', (evt) => {
        if(evt.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.documentElement.classList.remove('js-drawer-open', 'lock-scroll');
      document.body.removeEventListener('click', this.onBodyClick);
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.documentElement.classList.add('js-drawer-open', 'lock-scroll');
      document.body.addEventListener('click', this.onBodyClick);
      trapFocus(this);
    }
  });
}
